import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import SelectTeam from './SelectTeam'
import SelectGirone from './SelectGirone'
import SelectPeriodo from './SelectPeriodo'
import SelectRitardo from './SelectRitardo'
import SelectArbitro from './SelectArbitro'
import SelectSocieta from './SelectSocieta'
import SelectTessera from './SelectTessera'
import SelectStagione from './SelectStagione'
import SelectCategoria from './SelectCategoria'
import SelectCampionato from './SelectCampionato'
import SelectNumeroGara from './SelectNumeroGara'
import SelectArbitraggio from './SelectArbitraggio'
import SelectProvvedimento from './SelectProvvedimento'
import {
  useGetCampionatiQuery,
  useGetIscrizioniQuery,
} from '../../hooks/api-slice'
import {
  setAvailableStagioni,
  setAvailableCampionati,
  setAvailableCategorie,
  setAvailableGironi,
  setAvailableNumeriGara,
  setAvailableTeams,
  setAvailableProvvedimenti,
  setAvailableArbitraggi,
  setAvailablePeriodi,
  setAvailableRitardi,
  setAvailableTessere,
} from '../../container/selection'
import { useSelection } from '../../hooks/selection-check-functions'
import { getArePubblicati } from '../../hooks/utils-functions'
import {
  getStagioni,
  getCampionati,
  getCategorie,
  getGironi,
  getTeams,
  getNumeriGara,
  getProvvedimenti,
  getArbitraggi,
  getPeriodi,
  getRitardi,
  getTessere,
} from '../../hooks/selection-get-functions'

const SelectionBar = ({
  data,
  yStagione,
  yCampionato,
  yCategoria,
  yGirone,
  yTeam,
  yNumeroGara,
  yProvvedimento,
  yArbitraggio,
  yPeriodo,
  yRitardo,
  yArbitro,
  ySocieta,
  yTessera,
}) => {
  const { admin } = useSelector(state => state.home.infoUtente)
  const selectedCampionato = useSelector(
    state => state.selection.selectedCampionato,
  )
  const selectedCategoria = useSelector(
    state => state.selection.selectedCategoria,
  )
  const selectedCampionatoGironiPubblicati = useSelector(
    state => state.selection.selectedCampionatoGironiPubblicati,
  )
  const selectedCampionatoCalendariPubblicati = useSelector(
    state => state.selection.selectedCampionatoCalendariPubblicati,
  )

  const location = useLocation()

  const arePubblicati = getArePubblicati(
    selectedCampionatoGironiPubblicati,
    selectedCampionatoCalendariPubblicati,
    location.pathname?.split('/')?.[1],
  )

  const { data: campionati } = useGetCampionatiQuery()
  const { data: iscrizioniLight } = useGetIscrizioniQuery(
    { campionato: selectedCampionato, iFilter: 'light' },
    { skip: !(yTeam && selectedCampionato && (admin || arePubblicati)) },
  )

  const dispatch = useDispatch()

  const dataCategoria = useMemo(
    () => data?.filter(x => x.categoria === selectedCategoria),
    [data, selectedCategoria],
  )

  useEffect(() => {
    if (yStagione) dispatch(setAvailableStagioni(getStagioni(campionati)))
  }, [campionati, dispatch, yStagione])

  useEffect(() => {
    if (yCampionato) dispatch(setAvailableCampionati(getCampionati(campionati)))
  }, [campionati, dispatch, yCampionato])

  useEffect(() => {
    if (yCategoria) dispatch(setAvailableCategorie(getCategorie(data)))
  }, [data, dispatch, yCategoria])

  useEffect(() => {
    if (yGirone) dispatch(setAvailableGironi(getGironi(dataCategoria)))
  }, [dataCategoria, dispatch, yGirone])

  useEffect(() => {
    if (yTeam && iscrizioniLight)
      dispatch(setAvailableTeams(getTeams(dataCategoria, iscrizioniLight)))
  }, [dataCategoria, dispatch, iscrizioniLight, yTeam])

  useEffect(() => {
    if (yNumeroGara) dispatch(setAvailableNumeriGara(getNumeriGara(data)))
  }, [data, dispatch, yNumeroGara])

  useEffect(() => {
    if (yProvvedimento) dispatch(setAvailableProvvedimenti(getProvvedimenti()))
  }, [dispatch, yProvvedimento])

  useEffect(() => {
    if (yArbitraggio) dispatch(setAvailableArbitraggi(getArbitraggi()))
  }, [dispatch, yArbitraggio])

  useEffect(() => {
    if (yPeriodo) dispatch(setAvailablePeriodi(getPeriodi()))
  }, [dispatch, yPeriodo])

  useEffect(() => {
    if (yRitardo) dispatch(setAvailableRitardi(getRitardi()))
  }, [dispatch, yRitardo])

  useEffect(() => {
    if (yTessera) dispatch(setAvailableTessere(getTessere()))
  }, [dispatch, yTessera])

  useSelection(yArbitro, ySocieta)

  return (
    <>
      {yStagione && <SelectStagione />}
      {yCampionato && <SelectCampionato />}
      {yCategoria && <SelectCategoria />}
      {yGirone && <SelectGirone />}
      {yTeam && <SelectTeam />}
      {yProvvedimento && <SelectProvvedimento />}
      {yArbitraggio && <SelectArbitraggio />}
      {yPeriodo && <SelectPeriodo />}
      {yRitardo && <SelectRitardo />}
      {yNumeroGara && <SelectNumeroGara />}
      {yArbitro && <SelectArbitro />}
      {ySocieta && <SelectSocieta />}
      {yTessera && <SelectTessera />}
    </>
  )
}

export default SelectionBar
